export default __webpack_public_path__ + "static/media/arrowLeftBlue.8267dc88.svg";